import { ContactsItem } from '../ContactsItem';

export const ContactsList = ({
  rows = [],
  expandedId = null,
  editableIds = new Set(),
  handleToggle = () => {},
  handleEdit = () => {},
  handleRemove = () => {},
  handleLinkChange = () => {},
}) => {
  if (rows.length === 0) {
    return <span className="py-1.5 px-0.5 text-[13px] text-[#888]">No contacts.</span>;
  }

  return (
    <div className="flex flex-col gap-2 w-full">
      {rows.map(({ contact, link }) => (
        <ContactsItem
          key={contact.id}
          contact={contact}
          link={link}
          isOpen={expandedId === contact.id}
          isEditable={editableIds.has(contact.id)}
          handleToggle={handleToggle}
          handleEdit={handleEdit}
          handleRemove={handleRemove}
          handleLinkChange={handleLinkChange}
        />
      ))}
    </div>
  );
};
